import { MutationTree } from 'vuex'
import {
  PatientState,
  PatientListResponse,
  PatientDetail,
  ConsultationListItem,
  ResolutiveEvent,
  ObstetricEvent,
  SectionForm
} from './types'

export enum PatientMutations {
  SET_LOADER_PATIENTS_LIST = 'SET_LOADER_PATIENTS_LIST',
  SET_LOADER_PATIENT = 'SET_LOADER_PATIENT',
  SET_PATIENTS_LIST = 'SET_PATIENTS_LIST',
  SET_CURRENT_PATIENT = 'SET_CURRENT_PATIENT',
  SET_PATIENT_CONSULTATIONS = 'SET_PATIENT_CONSULTATIONS',
  SET_LOADER_CONSULTATIONS_LIST = 'SET_LOADER_CONSULTATIONS_LIST',
  SET_RESOLUTIVE_EVENT = 'SET_RESOLUTIVE_EVENT',
  SET_OBSTETRIC_EVENT = 'SET_OBSTETRIC_EVENT',
  SET_MORBIDITY_REGISTRY = 'SET_MORBIDITY_REGISTRY',
  SET_CLINICAL_HISTORY = 'SET_CLINICAL_HISTORY',
  SET_CURRENT_CONDITION = 'SET_CURRENT_CONDITION',
  SET_LOADER_CURRENTCONDITION = 'SET_LOADER_CURRENTCONDITION'
}

export const mutations: MutationTree<PatientState> = {
  [PatientMutations.SET_PATIENTS_LIST](
    state: PatientState,
    payload: PatientListResponse
  ) {
    state.patientsResponse = payload
  },

  [PatientMutations.SET_CURRENT_PATIENT](
    state: PatientState,
    payload: PatientDetail
  ) {
    state.patientDetail = payload
  },

  [PatientMutations.SET_LOADER_PATIENTS_LIST](
    state: PatientState,
    payload: boolean
  ) {
    state.loadingPatientsList = payload
  },

  [PatientMutations.SET_LOADER_PATIENT](state: PatientState, payload: boolean) {
    state.loadingPatient = payload
  },

  [PatientMutations.SET_LOADER_CONSULTATIONS_LIST](
    state: PatientState,
    payload: boolean
  ) {
    state.loadingConsultations = payload
  },

  [PatientMutations.SET_PATIENT_CONSULTATIONS](
    state: PatientState,
    consultations: Array<ConsultationListItem>
  ) {
    state.patientConsultationsList = consultations
  },

  [PatientMutations.SET_RESOLUTIVE_EVENT](
    state: PatientState,
    events: ResolutiveEvent
  ) {
    state.resolutiveEvent = events
  },

  [PatientMutations.SET_OBSTETRIC_EVENT](
    state: PatientState,
    events: ObstetricEvent
  ) {
    state.obstetricEvent = events
  },

  [PatientMutations.SET_MORBIDITY_REGISTRY](
    state: PatientState,
    events: SectionForm[]
  ) {
    state.morbidityRegistry = events
  },

  [PatientMutations.SET_CLINICAL_HISTORY](
    state: PatientState,
    events: SectionForm[]
  ) {
    state.clinicalHistory = events
  },

  [PatientMutations.SET_CURRENT_CONDITION](
    state: PatientState,
    events: SectionForm[]
  ) {
    state.currentCondition = events
  },

  [PatientMutations.SET_LOADER_CURRENTCONDITION](
    state: PatientState,
    events: boolean
  ) {
    state.loadingCurrentCondition = events
  }
}
